import { render, staticRenderFns } from "./ToastNotification.vue?vue&type=template&id=ed4d05c8&scoped=true"
import script from "./ToastNotification.vue?vue&type=script&lang=ts"
export * from "./ToastNotification.vue?vue&type=script&lang=ts"
import style0 from "./ToastNotification.vue?vue&type=style&index=0&id=ed4d05c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4d05c8",
  null
  
)

export default component.exports